import { api } from "./api";

export type FrequenciaAcordo = "diario" | "semanal" | "quinzenal" | "mensal" | "personalizado";
export type StatusAcordo = "ativo" | "quitado" | "quebrado" | "cancelado";
export type FormaPagamentoAcordo = "pix" | "dinheiro" | "transferencia";

export interface AcordoResponse {
  id: string;
  emprestimoId: string;
  valorOriginal: string;
  valorAcordado: string;
  desconto: string;
  numParcelas: number;
  frequencia: FrequenciaAcordo;
  intervaloDias: number | null;
  dataPrimeiraParcela: string;
  formaPagamento: FormaPagamentoAcordo;
  observacoes: string | null;
  status: StatusAcordo;
  createdAt: string;
  createdBy: string | null;
  quitadoAt: string | null;
  quebradoAt: string | null;
  canceladoAt: string | null;
}

export interface CreateAcordoData {
  valorAcordado: number;
  numParcelas: number;
  frequencia: FrequenciaAcordo;
  intervaloDias?: number;
  dataPrimeiraParcela: string;
  formaPagamento: FormaPagamentoAcordo;
  observacoes?: string;
}

export async function createAcordo(loanId: string, data: CreateAcordoData): Promise<AcordoResponse> {
  const response = await api.post<AcordoResponse>(`/loans/${loanId}/acordos`, data);
  return response.data!;
}

export async function listAcordos(loanId: string): Promise<AcordoResponse[]> {
  const response = await api.get<AcordoResponse[]>(`/loans/${loanId}/acordos`);
  return response.data || [];
}

export async function cancelAcordo(acordoId: string): Promise<AcordoResponse> {
  const response = await api.post<AcordoResponse>(`/loans/acordos/${acordoId}/cancel`, {});
  return response.data!;
}
